import { Button, Page } from "@towersystems/roam-common-native";
import React, { useCallback } from "react";
import { VerifyMfaCodeFieldset } from "../../components/SetupNative2faForm/components/VerifyMfaCodeFieldset";
import { useFormContext } from "react-hook-form";
import { Colors } from "react-native-ui-lib";
import { useSetup2fa } from "../../../../utilities/2fa/hooks";
import { SetupNative2faFormValues } from "../../components/SetupNative2faForm/types";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useFocusEffect } from "@react-navigation/native";
import { useTranslation } from "../../../../utilities/i18n";

export interface Native2faVerifyMfaCodeScreenProps {}

export const Native2faVerifyMfaCodeScreen = ({ navigation }: any) => {
  const { t } = useTranslation("settings");
  const { handleOnSubmit } = useSetup2fa();

  const { getValues, handleSubmit, reset, formState } = useFormContext<any>();

  const { isLoading, isSubmitting, isValid, isSubmitSuccessful } = formState;

  const disabled = isLoading || isSubmitting || !isValid || isSubmitSuccessful;

  function handleComplete() {
    navigation.popToTop();
  }

  async function handleFinalSubmit(values: SetupNative2faFormValues) {
    return handleOnSubmit(values)?.then((success) => {
      if (success) {
        handleComplete();
      }
    });
  }

  // undo any form state from future steps if we come back to this screen
  // it also resets the isSubmitSuccessful flag on the form ready
  // for a new submission
  useFocusEffect(
    useCallback(() => {
      const values = getValues();
      reset({
        ui: {
          ...values.ui,
        },
        data: {
          ...values.data,
        },
      });
    }, [reset])
  );

  const footerMarkup = (
    <Button
      disabled={disabled}
      label={"Confirm"}
      loading={isSubmitting}
      backgroundColor={Colors.action}
      color="white"
      onPress={handleSubmit(handleFinalSubmit)}
    ></Button>
  );

  return (
    <Page
      title={t("title.native_2fa_verify_code")}
      secondaryTitle={t("title.native_2fa_verify_code_secondary")}
      footer={footerMarkup}
    >
      <VerifyMfaCodeFieldset onComplete={handleComplete} />
    </Page>
  );
};
